import NavigationBlockPromptManager from './NavigationBlockPromptManager';

export default NavigationBlockPromptManager;
